<!--
 * @Author: AI Assistant
 * @Date: 2025-01-04
 * @Description: 音色选择组件
 * @FilePath: /weryai-web/components/Tool/GenderSelect.vue
-->
<template>
    <div class="mt-5">
        <!-- 整合容器 -->
        <div class="bg-[#1C1C20] rounded-lg p-[20px]">
            <!-- 标题 -->
            <label class="block text-[#A0A0A8] text-xs mb-2.5">
                {{ t('music.voiceTimbre') }}
            </label>
            
            <!-- 选项按钮 -->
            <div class="flex gap-3">
                <button
                    v-for="option in options"
                    :key="option.value"
                    @click="gender = option.value"
                    class="w-[107px] h-[42px] rounded-lg text-xs transition-all duration-200 border"
                    :class="[
                        gender === option.value
                            ? 'bg-[#F7FFF3]/10 text-white border-white/50'
                            : 'text-[#A0A0A8] border-white/[0.06] hover:border-white/20'
                    ]"
                >
                    {{ option.label }}
                </button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from '~/composables/useI18n'

const { t } = useI18n()

// 音色选项
const options = computed(() => [
    { value: 'm' as const, label: t('music.maleVoice') },
    { value: 'f' as const, label: t('music.femaleVoice') },
])

// 双向绑定
const gender = defineModel<'m' | 'f'>('gender', {
    default: 'm',
})
</script>

